import angular from 'angular';
import Navbar from './navbar/navbar';
import BalanceChart from './balanceChart/balanceChart';
import HistoryChart from './historyChart/historyChart';
import Sidenav from './sidenav/sidenav';
import AutoRefreshCheck from './autoRefreshCheck/autoRefreshCheck';
import Pagination from './pagination/pagination';
import PaginationRemote from './pagination-remote/paginationRemote';
import MerchantTermsModal from './merchantTermsModal/merchantTermsModal';
import Modal from './modal/modal';
import Searchbar from './searchbar/searchbar';
import ActivationHourServices from './activationHourServices/activationHourServices';
import MapsAddress from './mapsAddress/mapsAddress';
import StoreSelect from './storeSelect/storeSelect';

const componentsModule = angular.module('tinaba.common.components', [
  Navbar.name,
  BalanceChart.name,
  HistoryChart.name,
  Sidenav.name,
  Pagination.name,
  PaginationRemote.name,
  Modal.name,
  MerchantTermsModal.name,
  Searchbar.name,
  ActivationHourServices.name,
  MapsAddress.name,
  StoreSelect.name,
  AutoRefreshCheck.name
]);

export default componentsModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/components.js
 **/